/**
 * The two dates a Waiting row answers for.
 * For Media Devoted | Created By Ciro Autiero
 */

import type { QueueElement } from '@trafficpulse/shared';

/**
 * When the CURRENT wait began.
 *
 * `waitingSince` is stamped when a row is parked. It is null for a row that was
 * never live — and for one of those the honest answer is the day it joined the
 * bank, because that is exactly how long it has been sitting here. Rows that
 * predate the column read null too, and get the same correct answer.
 *
 * Deliberately NOT `queuedAt`: parking leaves that stamp untouched, so on a
 * path that ran for a week it still points at the day it entered the queue LINE
 * — a date from before it ever went live.
 */
export function waitingSinceOf(el: QueueElement): string | null {
  return el.waitingSince ?? el.addedAt ?? null;
}

/** True when the row has been parked at least once, so the two dates differ. */
export function wasParked(el: QueueElement): boolean {
  return Boolean(el.waitingSince);
}
